
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.647 28.125c5.882-3.125 8.824-3.125 14.706 0m-20.588-7.812c11.764-6.25 14.706-6.25 26.47 0","stroke":"#005149","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('circle',{attrs:{"cx":"25","cy":"25","r":"24","stroke":"#005149","stroke-width":"2"}}),_c('path',{attrs:{"d":"M25.97 35.938c0 .615-.462 1.062-.97 1.062s-.97-.447-.97-1.063c0-.615.462-1.062.97-1.062s.97.447.97 1.063z","fill":"#005149","stroke":"#005149"}})])
          )
        }
      }
    